import { patchRequest } from "../api/ApiService";
import { logError } from "../services/utils";

const approvalsAPI = `${process.env.REACT_APP_API_URL}team/approvals/`;

export default class ApprovalService {
  static instance;
  _approvals = {};

  constructor() {
    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
    this._approvals = this.initialState;
  }

  get approvals() {
    return this._approvals;
  }

  get url() {
    return approvalsAPI;
  }

  initialize(data) {
    let approvals = this.initialState;

    data.forEach(item => {
      if (item.content_type in approvals) {
        approvals[item.content_type].push({
          id: item.id,
          approved: item.approved,
          content_type: item.content_type
        });
      }
    });

    this._approvals = approvals;

    return this.approvals;
  }

  get initialState() {
    return {
      product: [],
      "account receivable term": [],
      "price forecast": [],
      promo: [],
      sales: [],
      "team factory": [],
      "team machine": [],
      "product manufacture": [],
      "account payable term": [],
      "team debt": [],
      "team debt repayment": [],
      "team equity": []
    };
  }

  /**
   * List of approvals
   */
  getApprovalsList(keys) {
    let res = [];
    keys.forEach(key => {
      if (key in this._approvals) {
        res = res.concat(this._approvals[key]);
      }
    });

    return res;
  }

  get productDevelopment() {
    return this.getApprovalsList(["product"]);
  }

  get productMarketing() {
    return this.getApprovalsList([
      "account receivable term",
      "price forecast",
      "promo",
      "sales"
    ]);
  }

  get operations() {
    return this.getApprovalsList([
      "team factory",
      "team machine",
      "product manufacture",
      "account payable term"
    ]);
  }

  get finance() {
    return this.getApprovalsList([
      "team debt",
      "team debt repayment",
      "team equity"
    ]);
  }

  /**
   * Approvals status
   */
  getApprovalStatus(data) {
    let status = true;
    let len = 0;

    data.forEach(item => {
      len += 1;
      if (item.approved === false) {
        status = false;
      }
    });

    if (len > 0) {
      return status;
    }

    return false;
  }

  get productDevelopmentStatus() {
    return this.getApprovalStatus(this.productDevelopment);
  }

  get productMarketingStatus() {
    return this.getApprovalStatus(this.productMarketing);
  }

  get operationsStatus() {
    return this.getApprovalStatus(this.operations);
  }

  get financeStatus() {
    return this.getApprovalStatus(this.finance);
  }

  /**
   * Update approvals methods
   */
  getApprovalIds(data) {
    let ids = [];
    data.forEach(item => {
      ids.push({
        id: item.id,
        content_type: item.content_type
      });
    });

    return ids;
  }

  getApproveRequest(id, is_approved) {
    return patchRequest(`${approvalsAPI}${id}/`).send({
      approved: is_approved
    });
  }

  updateApprovals(ids, is_approved) {
    let requests = [];
    ids.forEach(item => {
      requests.push(this.getApproveRequest(item.id, is_approved));
    });

    if (requests.length === 0) {
      return new Promise((resolve, reject) => {
        resolve(this.approvals);

        return null;
      });
    }

    let approvals = this._approvals;
    const joinRequests = Promise.all(requests);
    return joinRequests
      .then(res => {
        ids.forEach(item => {
          if (item.content_type in approvals) {
            approvals[item.content_type].find(
              i => i.id === item.id
            ).approved = is_approved;
          }
        });

        this._approvals = approvals;
        return new Promise((resolve, reject) => {
          resolve(this.approvals);

          return null;
        });
      })
      .catch(err => {
        logError(err, "ApprovalService", "updateApprovals");
      });
  }

  updateProductDevelopment(is_approved) {
    return this.updateApprovals(
      this.getApprovalIds(this.productDevelopment),
      is_approved
    );
  }

  updateProductMarketing(is_approved) {
    return this.updateApprovals(
      this.getApprovalIds(this.productMarketing),
      is_approved
    );
  }

  updateOperations(is_approved) {
    return this.updateApprovals(
      this.getApprovalIds(this.operations),
      is_approved
    );
  }

  updateFinance(is_approved) {
    return this.updateApprovals(this.getApprovalIds(this.finance), is_approved);
  }
}



// WEBPACK FOOTER //
// ./src/api/ApprovalService.js